import {
    DROPDOWN_INIT,
    DROPDOWN_TOGGLE,
    DROPDOWN_CLOSE,
    DROPDOWN_SELECT
} from '../actions';

const initialState = {
    opened: false,
    selected: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case DROPDOWN_INIT:
            return Object.assign({}, state, {
                selected: action.defaultValue
            });

        case DROPDOWN_TOGGLE:
            return Object.assign({}, state, {
                opened: !state.opened
            });

        case DROPDOWN_CLOSE:
            return Object.assign({}, state, {
                opened: false
            });

        case DROPDOWN_SELECT:
            return Object.assign({}, state, {
                opened: false,
                selected: action.value
            });

        default:
            return state;
    }
}

export function createReducer(stateKey) {
    return (state = initialState, action) => {
        if (!action.stateKey || action.stateKey !== stateKey) {
            return state;
        }

        return reducer(state, action);
    };
}



// WEBPACK FOOTER //
// ./src/js/modules/Dropdown/reducers/index.js